import * as Yup from "yup";
import { PublisherFormValues } from "./types";

export const apiEndpoint = `/publishers`;
export type ColumnKey = "name" | "jsonConfig" | "createdAt" | "updatedAt";
export const ColumnOptions: { value: ColumnKey; label: string }[] = [
  { value: "name", label: "Name" },
  { value: "jsonConfig", label: "Json Config" },
  { value: "createdAt", label: "Created At" },
  { value: "updatedAt", label: "Updated At" },
];

// Publisher Form: validation, fields and initial values (patterned after title module)
export const PublisherValidationSchema = Yup.object({
  name: Yup.string().trim().required("Name is required"),
  jsonConfig: Yup.string().test("is-json", "Invalid JSON format", (value) => {
    try {
      JSON.parse(value ?? "");
      return true;
    } catch {
      return false;
    }
  }),
});

export const PublisherFormInitialValues: PublisherFormValues = {
  name: "",
  jsonConfig: "",
};

export const PublisherFormFields = [
  { name: "name", label: "Name", type: "text" },
  { name: "jsonConfig", label: "Json Config", type: "json" },
];

export const DefaultHiddenColumns: ColumnKey[] = ["createdAt", "updatedAt"];

// Server-side sorting state (limited to allowed fields)
export const AllowedSortFields = [
  "name",
  "jsonConfig",
  "createdAt",
  "updatedAt",
] as const;
